import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as XLSX from 'sheetjs-style';

const OverAllReport = () => {
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState('');
    const [selectedOrganization, setSelectedOrganization] = useState('');
    const [candidates, setCandidates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const tableRef = useRef();

    useEffect(() => {
        axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab/')
            .then(res => setBatchNumbers(res.data.map(item => item.batch_no)))
            .catch(err => console.error('Batch No Error:', err));

        axios.get('https://api.eazyworldehsengineering.com/api/organization_details/')
            .then(res => setOrganizations(res.data.map(item => item.organ_name)))
            .catch(err => console.error('Organization Error:', err));
    }, []);

    const fetchReport = async () => {
        if (!selectedBatch || !selectedOrganization) {
            alert("Please select both Batch No and Organization.");
            return;
        }
        setIsLoading(true);
        try {
            const res = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/report/overall`, {
                params: {
                    batch_no: selectedBatch,
                    organ_name: selectedOrganization
                }
            });
            setCandidates(res.data.data);
            setShowReport(true);
        } catch (err) {
            console.error(err);
            alert("Failed to fetch report");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
        let y = 30;

        doc.setFontSize(14);
        doc.text("Overall Report", 40, y);
        y += 20;
        doc.setFontSize(11);
        doc.text(`Batch No: ${selectedBatch}`, 40, y);
        doc.text(`Organization: ${selectedOrganization}`, 300, y);
        y += 20;
        doc.setFontSize(10);
        doc.text("SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation", 40, y);

        autoTable(doc, {
            html: '#overallReportTable',
            startY: y + 20,
            styles: { fontSize: 6, cellPadding: 2 },
            headStyles: { fillColor: [52, 58, 64], textColor: [255, 255, 255] },
        });

        doc.save("OverAllReport.pdf");
    };

    const handlePrintReport = () => {
        const title1 = `Batch: ${selectedBatch} | Organization: ${selectedOrganization}`;
        const title2 = `SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation`;

        let html = `
    <html>
    <head>
        <title>Overall Report</title>
        <style>
            @page { size: A4 landscape; margin: 10mm; }
            body { font-family: Arial, sans-serif; font-size: 10pt; }
            h1 { text-align: center; font-size: 16pt; margin-bottom: 5px; }
            h2 { text-align: center; font-size: 12pt; margin-top: 0; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; table-layout: fixed; }
            th, td { border: 1px solid #000; padding: 4px; text-align: center; word-wrap: break-word; }
            th { background-color: #4F81BD; color: #fff; font-size: 9pt; }
            td { font-size: 9pt; }
            .footer-table { width: 100%; margin-top: 10px; border-collapse: collapse; }
            .footer-table td { border: none; font-size: 10pt; padding: 10px; vertical-align: top; }
        </style>
    </head>
    <body>
        <h1>${title1}</h1>
        <h2>${title2}</h2>
        <table>
            <thead>
                <tr>
                    <th>R.No</th><th>Name</th><th>Designation</th><th>Organization</th><th>Exp</th>
                    <th>Pre Eva</th><th>Post Eva</th><th>SS</th><th>WS</th><th>LC</th><th>S</th><th>DPOC</th><th>PO</th>
                    <th>Interaction</th><th>Attentive</th><th>Attitude</th><th>Overall</th><th>Grade</th>
                    <th>Remarks</th><th>Evaluated On</th><th>Evaluated By</th>
                </tr>
            </thead>
            <tbody>
    `;

        candidates.forEach(row => {
            html += `
        <tr>
            <td>${row.sr_no || ''}</td>
            <td>${row.Name || ''}</td>
            <td>${row.designation || ''}</td>
            <td>${row.organization || ''}</td>
            <td>${row.total_year_exp || ''}</td>
            <td>${row.pre_evaluation_test || ''}</td>
            <td>${row.post_evaluation_test || ''}</td>
            <td>${row.safety_sys || ''}</td>
            <td>${row.work_safety || ''}</td>
            <td>${row.loadchart_grade || ''}</td>
            <td>${row.signals_grade || ''}</td>
            <td>${row.pre_operational_grade || ''}</td>
            <td>${row.practical_opt_grade || ''}</td>
            <td>${row.interaction || ''}</td>
            <td>${row.attentive || ''}</td>
            <td>${row.attitude || ''}</td>
            <td>${row.overal_perform || ''}</td>
            <td>${row.final_grade || ''}</td>
            <td>${row.evaluate_grade_status || ''} - ${row.evaluate_remark || ''}</td>
            <td>${row.evaluated_date ? new Date(row.evaluated_date).toLocaleDateString('en-GB') : ''}</td>
            <td>${row.evaluated_by || ''}</td>
        </tr>
    `;
        });

        html += `
            </tbody>
        </table>

        <!-- Footer Section -->
        <table class="footer-table">
            <tr>
                <td>Coordinated By: ____________________</td>
                <td>Evaluated By: ____________________</td>
                <td>Approved By: ____________________</td>
            </tr>
        </table>
    </body>
    </html>
    `;

        const printWindow = window.open('', '', 'width=900,height=650');
        printWindow.document.write(html);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };


    const handleDownloadExcel = () => {
        const ws = XLSX.utils.aoa_to_sheet([]);

        // ======= TITLE ROWS =======
        const title1 = [`Batch: ${selectedBatch} | Organization: ${selectedOrganization}`];
        const title2 = ["SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation"];

        XLSX.utils.sheet_add_aoa(ws, [title1, title2, []], { origin: "A1" });

        // ======= MERGES =======
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 20 } }, // Title 1 merge
            { s: { r: 1, c: 0 }, e: { r: 1, c: 20 } }, // Title 2 merge
        ];

        // ======= HEADER ROWS =======
        const headersRow1 = [
            "R.No", "Name", "Designation", "Organization", "Exp",
            "Pre Eva", "Post Eva",
            "SS", "WS", "LC", "S", "DPOC", "PO",
            "Interaction", "Attentive", "Attitude",
            "Overall", "Grade", "Remarks", "Evaluated On", "Evaluated By"
        ];

        XLSX.utils.sheet_add_aoa(ws, [headersRow1], { origin: "A4" });

        // ======= BODY ROWS =======
        const body = candidates.map(row => [
            row.sr_no,
            row.Name,
            row.designation,
            row.organization,
            row.total_year_exp,
            row.pre_evaluation_test,
            row.post_evaluation_test,
            row.safety_sys,
            row.work_safety,
            row.loadchart_grade,
            row.signals_grade,
            row.pre_operational_grade,
            row.practical_opt_grade,
            row.interaction,
            row.attentive,
            row.attitude,
            row.overal_perform,
            row.final_grade,
            `${row.evaluate_grade_status}-${row.evaluate_remark}`,
            row.evaluated_date ? new Date(row.evaluated_date).toLocaleDateString('en-GB') : '',
            row.evaluated_by,
        ]);

        XLSX.utils.sheet_add_aoa(ws, body, { origin: -1 });

        // ======= FOOTER (Optional Signature Row) =======
        XLSX.utils.sheet_add_aoa(ws, [["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]], { origin: -1 });
        XLSX.utils.sheet_add_aoa(ws, [["Coordinated By", "Evaluated By", "Checked By", "Approved By"]], { origin: -1 });

        // ======= STYLING =======
        const range = XLSX.utils.decode_range(ws["!ref"]);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws[cellAddress];
                if (!cell) continue;

                let style = {
                    font: { sz: 11, color: { rgb: "000000" } },
                    alignment: { vertical: "center", horizontal: "center", wrapText: true },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };

                if (R === 0) { // Main Title
                    style.font = { bold: true, sz: 16 };
                } else if (R === 1) { // Subtitle
                    style.font = { sz: 12 };
                } else if (R === 3) { // Header Row
                    style.font = { bold: true, color: { rgb: "FFFFFF" }, sz: 10 };
                    style.fill = { fgColor: { rgb: "4F81BD" } };
                } else {
                    style.font = { sz: 10 };
                }

                cell.s = style;
            }
        }

        // ======= COLUMN WIDTHS =======
        ws["!cols"] = [
            { wch: 6 },   // R.No
            { wch: 18 },  // Name
            { wch: 15 },  // Designation
            { wch: 25 },  // Organization
            { wch: 8 },   // Exp
            { wch: 10 },  // Pre Eva
            { wch: 10 },  // Post Eva
            { wch: 6 }, { wch: 6 }, { wch: 6 }, { wch: 6 }, { wch: 8 }, { wch: 8 }, // SS - PO
            { wch: 12 },  // Interaction
            { wch: 12 },  // Attentive
            { wch: 12 },  // Attitude
            { wch: 10 },  // Overall
            { wch: 8 },   // Grade
            { wch: 20 },  // Remarks
            { wch: 12 },  // Evaluated On
            { wch: 15 },  // Evaluated By
        ];

        // ======= ROW HEIGHTS =======
        ws["!rows"] = [
            { hpt: 25 }, // Title
            { hpt: 20 }, // Subtitle
            { hpt: 10 }, // Empty
            { hpt: 25 }, // Header
        ];

        // ======= CREATE & DOWNLOAD =======
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Overall Report");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
        saveAs(blob, "OverAllReport.xlsx");
    };



    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <h1>Overall Report</h1>
                </div>
            </section>

            <section className="content">
                <div className="container-fluid">
                    <div className="card card-primary card-outline">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <label>Select Batch Number</label>
                                    <select className="form-control" value={selectedBatch} onChange={(e) => setSelectedBatch(e.target.value)}>
                                        <option value="">-- Select Batch No --</option>
                                        {batchNumbers.map((batch, idx) => (
                                            <option key={idx} value={batch}>{batch}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-5">
                                    <label>Select Organization</label>
                                    <select className="form-control" value={selectedOrganization} onChange={(e) => setSelectedOrganization(e.target.value)}>
                                        <option value="">-- Select Organization --</option>
                                        {organizations.map((org, idx) => (
                                            <option key={idx} value={org}>{org}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button className="btn btn-primary w-100" onClick={fetchReport}>View</button>
                                </div>
                            </div>

                            {isLoading && <div className="text-center text-muted">Loading...</div>}

                            {showReport && (
                                <>
                                    <div className="text-right mb-2">
                                        <button className="btn btn-danger btn-sm mr-2" onClick={handlePrintReport}>print</button>
                                        <button className="btn btn-success btn-sm" onClick={handleDownloadExcel}>Excel</button>
                                    </div>

                                    <div ref={tableRef}>
                                        <p className="text-center font-weight-bold">Batch: {selectedBatch} | Organization: {selectedOrganization}</p>
                                        <p className="text-center">
                                            <strong>SS</strong>-Safety Systems,&nbsp;
                                            <strong>WS</strong>-Work Safety,&nbsp;
                                            <strong>LC</strong>-Load Chart,&nbsp;
                                            <strong>S</strong>-Signals,&nbsp;
                                            <strong>DPOC</strong>-Daily/Pre-op Checks,&nbsp;
                                            <strong>PO</strong>-Practical Operation
                                        </p>

                                        <div className="table-responsive">
                                            <table id="overallReportTable" className="table table-bordered table-sm table-striped">
                                                <thead className="bg-secondary text-white">
                                                    <tr>
                                                        <th>R.No</th>
                                                        <th>Name</th>
                                                        <th>Designation</th>
                                                        <th>Organization</th>
                                                        <th>Exp</th>
                                                        <th>Pre Eva</th>
                                                        <th>Post Eva</th>
                                                        <th>SS</th>
                                                        <th>WS</th>
                                                        <th>LC</th>
                                                        <th>S</th>
                                                        <th>DPOC</th>
                                                        <th>PO</th>
                                                        <th>Interaction</th>
                                                        <th>Attentive</th>
                                                        <th>Attitude</th>
                                                        <th>Overall</th>
                                                        <th>Grade</th>
                                                        <th>Remarks</th>
                                                        <th>Evaluated On</th>
                                                        <th>Evaluated By</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {candidates.map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td>{row.sr_no}</td>
                                                            <td>{row.Name}</td>
                                                            <td>{row.designation}</td>
                                                            <td>{row.organization}</td>
                                                            <td>{row.total_year_exp}</td>
                                                            <td>{row.pre_evaluation_test}</td>
                                                            <td>{row.post_evaluation_test}</td>
                                                            <td>{row.safety_sys}</td>
                                                            <td>{row.work_safety}</td>
                                                            <td>{row.loadchart_grade}</td>
                                                            <td>{row.signals_grade}</td>
                                                            <td>{row.pre_operational_grade}</td>
                                                            <td>{row.practical_opt_grade}</td>
                                                            <td>{row.interaction}</td>
                                                            <td>{row.attentive}</td>
                                                            <td>{row.attitude}</td>
                                                            <td>{row.overal_perform}</td>
                                                            <td>{row.final_grade}</td>
                                                            <td>{row.evaluate_grade_status}-{row.evaluate_remark}</td>
                                                            <td>{row.evaluated_date}</td>
                                                            <td>{row.evaluated_by}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OverAllReport;
